module.exports = __webpack_public_path__ + "img/avatar3.afd5d57a.png";